/**
 * @deprecated - use country code from @nitra/nkmb-theme instead
 */
export var ECountryCode;
(function (ECountryCode) {
    ECountryCode["SLOVENIA"] = "SVN";
    ECountryCode["CROATIA"] = "HRV";
    ECountryCode["SWEDEN"] = "SWE";
    ECountryCode["ARGENTINA"] = "ARG";
    ECountryCode["NIGERIA"] = "NGA";
    ECountryCode["SERBIA"] = "SRB";
    ECountryCode["KOSOVO"] = "UNMIK";
    ECountryCode["NETHERLANDS"] = "NLD";
    ECountryCode["AUSTRIA"] = "AUT";
    ECountryCode["BOSNIA_AND_HERZEGOVINA"] = "BIH";
    ECountryCode["MONTENEGRO"] = "MNE";
})(ECountryCode || (ECountryCode = {}));
